module.exports = __webpack_public_path__ + "static/TextureBackground03-5221e29bd1ab715c26ad85815adea098.jpg";